export const UIMessageLayout = {
    Default: 'default',
    Light: 'light',
} as const;

export type UIMessageLayoutValue =
    (typeof UIMessageLayout)[keyof typeof UIMessageLayout];

export const UIMessageType = {
    Info: 'info',
    Success: 'success',
    Warning: 'warning',
    Error: 'error',
    Urgent: 'urgent',
    LightWarning: 'light-warning',
    LightError: 'light-error',
} as const;

export type UIMessageTypeValue =
    (typeof UIMessageType)[keyof typeof UIMessageType];

export interface MessageConfig {
    type: UIMessageTypeValue;
    layout?: UIMessageLayoutValue;
    content?: string;
    messages?: Array<string>;
    closable?: boolean | undefined;
    code?: string | undefined;
    persistent?: boolean | undefined;
}
